module.exports = __webpack_public_path__ + "img/var_str.2886515.svg";